import { render, staticRenderFns } from "./PurchaseOffersIn.vue?vue&type=template&id=552455aa&"
import script from "./PurchaseOffersIn.vue?vue&type=script&lang=js&"
export * from "./PurchaseOffersIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports